import React from 'react';
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { useAccount, useDisconnect } from 'wagmi'
import { Button } from '../components/ui/button';
import { Wallet } from 'lucide-react';

const WalletButton = () => {
  const { open } = useWeb3Modal()
  const { address, isConnected } = useAccount()
  const { disconnect } = useDisconnect()

  const formatAddress = (addr) => {
    if (!addr) return '';
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  const handleConnect = () => {
    open()
  };

  const handleDisconnect = () => {
    disconnect()
  };

  if (isConnected && address) {
    return (
      <Button
        onClick={handleDisconnect}
        className="bg-[#00FFD1] text-black hover:bg-[rgba(0,255,209,0.8)] border-0 rounded-none h-14 px-6 text-lg font-medium"
      >
        {formatAddress(address)}
      </Button>
    );
  }

  return (
    <Button
      onClick={handleConnect}
      className="bg-[#00FFD1] text-black hover:bg-[rgba(0,255,209,0.8)] border-0 rounded-none h-14 px-6 text-lg font-medium flex items-center gap-3"
    >
      <Wallet className="w-5 h-5" />
      Connect Wallet
    </Button>
  );
};

export default WalletButton;
